import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDriverById } from '../../services/DriversService';
import { DriverDetails } from '../../types/Drivers';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDriverById(id: string, fleetId: string, enabled: boolean = true, refetch: boolean = true): UseQueryResult<DriverDetails> {
  return useQuery(
    ['driver', id, fleetId],
    async (): Promise<DriverDetails> => getDriverById(id, fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: refetch ? FeaturesManagement.productivity.refetchInterval : false,
      enabled: !!id && enabled,
    },
  );
}

export default useGetDriverById;
